import { createApp } from 'vue';
import { createPinia } from 'pinia';

import App from './App.vue';
import router from './router';
import { i18n } from './plugins/i18n';

// Telegrafen's core bundle self-imports its own component CSS.
// The Telegrafen *global* stylesheet is imported from `main.css` instead, so it
// can be placed in a cascade layer that sits below Tailwind's utilities.
import './assets/main.css';

createApp(App).use(createPinia()).use(router).use(i18n).mount('#app');
